import { addCompiler } from '@mariobuikhuizen/vue-compiler-addon';
import Vue from 'vue';
addCompiler(Vue);
export default Vue;